import * as yup from 'yup';

const cezanneCredentialsFormSchema = yup.object().shape({
  baseUrl: yup.string().required('Base URL is mandatory').url('Enter a valid URL'),
  authTokenUrl: yup.string().required('Token URL is mandatory').url('Enter a valid URL'),
  authClientId: yup.string().required('Client ID is mandatory'),
  clientSecret: yup.string().required('Client secret is mandatory'),
  authScope: yup.string().required('Scope is mandatory'),
});

export default cezanneCredentialsFormSchema;
